import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
export const exitRuleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "规则类型名称",
            prop: "ruleName",
            type: "select",
            dicData: DIC.RULE_PARAMETERS,
        },
        {
            label: "规则类型判定时间",
            prop: "ruleParameters",
            placeholder:"请输入规则类型判定时间默认单位天（例如：30）",
            type: "input"
        },
        {
            label: "参数值",
            prop: "correlationValue",
            type: "input"
        },
        {
            label: "单位",
            prop: "unit",
            type: "input"
        },
        {
            label: "对比关系",
            prop: "correlation",
            type: "select",
            dicData: DIC.EXIT_RULE_CONTRAST,
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};